import { Leaf, Sparkles, Droplets, Snowflake, Wrench, type LucideIcon } from "lucide-react";
import { motion } from "framer-motion";

type Service = {
  icon: LucideIcon;
  title: string;
  items: string[];
};

const services: Service[] = [
  {
    icon: Leaf,
    title: "Gartenarbeit & Pflege",
    items: [
      "Rasenmähen",
      "Heckenschneiden",
      "Grünschnitt & Entsorgung",
      "Gartenpflege nach Wunsch",
    ],
  },
  {
    icon: Sparkles,
    title: "Reinigung",
    items: [
      "Haus- & Wohnungsreinigung",
      "Stiegenhausreinigung",
      "Büroreinigung",
    ],
  },
  {
    icon: Droplets,
    title: "Hochdruckreinigung",
    items: ["Terrassen", "Einfahrten", "Gehwege"],
  },
  {
    icon: Snowflake,
    title: "Winterdienst",
    items: ["Schneeräumung", "Streudienst", "Außenflächen"],
  },
  {
    icon: Wrench,
    title: "Hausmeisterservice",
    items: [
      "Räumungen",
      "Renovierungen aller Art",
      "Wartung und Instandhaltung von Gebäuden",
    ],
  },
];

export const Services = () => {
  return (
    <section id="leistungen" className="section-pad bg-background">
      <div className="container-narrow">
        <div className="mb-14 text-center">
          <span className="eyebrow text-secondary">Was wir bieten</span>
          <h2 className="h2-display mt-3 text-primary">Unsere Leistungen</h2>
          <span className="gold-underline" />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
                className="group rounded-xl bg-card p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover"
              >
                <div
                  className="mb-5 flex h-12 w-12 items-center justify-center"
                  style={{
                    background: "rgba(45,106,79,0.1)",
                    borderRadius: 10,
                  }}
                >
                  <Icon className="h-6 w-6 text-secondary" strokeWidth={2} />
                </div>
                <h3 className="h3-display text-primary">{s.title}</h3>
                <ul className="mt-4 space-y-2">
                  {s.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-3 text-[14px] text-muted-foreground"
                    >
                      <span
                        className="mt-2 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-accent"
                        aria-hidden
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
